import { Link, useMatch, useRouter } from '@tanstack/react-router';
import { ArrowLeftIcon } from 'lucide-react';

import { ArticleDetailsContent } from '@/components/ArticleDetailsContent';
import { Button } from '@/components/ui/button';
import { useNewsArticle } from '@/hooks/useNewsArticle';

export default function ArticleDetails() {
  const router = useRouter();
  const { params } = useMatch({ from: '/article/$id' });
  const articleId = params.id;

  const { data: article, isLoading } = useNewsArticle({ id: articleId });

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-neutral-50">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-neutral-800 border-t-transparent"></div>
      </div>
    );
  }

  if (!article) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-neutral-50">
        <div className="text-center">
          <h1 className="mb-4 text-2xl font-bold text-neutral-800">
            Articolul nu a fost găsit
          </h1>
          <Button asChild>
            <Link to="/">Înapoi la Știri</Link>
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-neutral-50">
      <div className="mx-auto max-w-3xl px-4 py-8">
        <Button
          variant="ghost"
          className="mb-6"
          onClick={() => router.navigate({ to: '/' })}>
          <ArrowLeftIcon className="mr-2 h-4 w-4" />
          Înapoi la Știri
        </Button>

        <div className="rounded-lg bg-white p-6 shadow-md">
          <ArticleDetailsContent article={article} />
        </div>
      </div>
    </div>
  );
}
